"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHistoryMessageSchema = exports.RecordHistoryMessageSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
const HistoryMessageFields = {
    teamId: typebox_1.Type.Optional(core_1.IdSchema),
    userId: typebox_1.Type.Optional(core_1.IdSchema),
    campaignId: typebox_1.Type.Optional(core_1.IdSchema),
    subjectId: (0, core_1.Nullable)(core_1.IdSchema),
    timestamp: core_1.TimestampSchema,
    type: ruby_1.HistoryRecordTypeSchema,
    level: ruby_1.HistoryLevelSchema,
    before: typebox_1.Type.Optional((0, core_1.JSONObject)({}, {})),
    after: typebox_1.Type.Optional((0, core_1.JSONObject)({}, {})),
};
exports.RecordHistoryMessageSchema = (0, core_1.StrictObject)(HistoryMessageFields, {
    title: "History record messages",
    description: "Record relating to a campaign",
});
function createHistoryMessageSchema(historyType, payloadSchema, options = {}) {
    return (0, core_1.StrictObject)({
        ...HistoryMessageFields,
        type: typebox_1.Type.Literal(historyType),
        before: typebox_1.Type.Optional(payloadSchema),
        after: typebox_1.Type.Optional(payloadSchema),
    }, options);
}
exports.createHistoryMessageSchema = createHistoryMessageSchema;
